export default __webpack_public_path__ + "static/media/Silk-Serif-Bold-Italic.e9a30cba.otf";